import UnifiedResourcesTable from "./UnifiedResourcesTable";

const ResourcesScreen = () => {
  return <UnifiedResourcesTable />;
};

export default ResourcesScreen;
